<template>
  <IconPiggy v-if="buybackIconExperiment === 'withPiggy'" v-bind="$attrs" />
  <IconHand v-else-if="buybackIconExperiment === 'withHand'" v-bind="$attrs" />
  <IconPlusRecycle v-else v-bind="$attrs" />
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import IconHand from '../IconHand/IconHand.vue'
import IconPiggy from '../IconPiggy/IconPiggy.vue'
import IconPlusRecycle from '../IconPlusRecycle/IconPlusRecycle.vue'

defineOptions({ inheritAttrs: false })

const experiments = useExperiments()
const buybackIconExperiment = experiments['experiment.buybackIconV2']
</script>
